import { useQuery } from '@tanstack/react-query';
import { useEffect, useState } from 'react';
import { apiClient } from '@/api/client';
import { API_ATTACHMENTS } from '@/api/endpoints';
import { ATTACHMENT_QUERY_KEY } from '@/api/queryKeys';
import { unwrapAxiosResponse } from '@/utils/axios';
import { hasPdfExtension, revokeObjectUrlLater } from '@/utils/file';
import { joinPath } from '@/utils/global';

export const useAttachmentBlobUrl = (
  attachmentId: string,
  name: string,
): string | undefined => {
  const [blobUrl, setBlobUrl] = useState<string>();

  const isPdf = hasPdfExtension(name);

  const { data: blob } = useQuery<Blob>({
    queryKey: [...ATTACHMENT_QUERY_KEY, attachmentId],
    queryFn: () =>
      apiClient
        .get<Blob>(joinPath(API_ATTACHMENTS, attachmentId), {
          responseType: 'blob',
        })
        .then(unwrapAxiosResponse),
    staleTime: Infinity,
  });

  useEffect(() => {
    if (!blob) {
      return;
    }

    const typedBlob = isPdf
      ? new Blob([blob], { type: 'application/pdf' })
      : blob;
    const objectUrl = URL.createObjectURL(typedBlob);

    setBlobUrl(objectUrl);

    return () => {
      revokeObjectUrlLater(objectUrl);
    };
  }, [blob, isPdf]);

  return blobUrl;
};
